import getDistance from 'geolib/es/getDistance';

import type { Location, StoreWithDistance } from '@context/StoresContext';

type ShopperGeo = Pick<Location, 'latitude' | 'longitude'>;

export function getDistanceFromShopperToStore(
  store: StoreWithDistance,
  shopperGeolocation?: ShopperGeo | null
): number | undefined {
  if (
    shopperGeolocation?.latitude == null ||
    shopperGeolocation?.longitude == null
  ) {
    return undefined;
  }

  const { latitude: lat1, longitude: lon1 } = shopperGeolocation;
  const { latitude: lat2, longitude: lon2 } = store.data.geo;
  if (
    ![lat1, lon1, lat2, lon2].every(
      (n) => typeof n === 'number' && !Number.isNaN(n)
    )
  ) {
    return undefined;
  }

  return getDistance(
    { latitude: lat1, longitude: lon1 },
    { latitude: lat2, longitude: lon2 }
  );
}
